export function isValidTelephoneNumber(str: any) {
    if (typeof str !== "string") {
        return false;
    }
    return !!str.match(
        /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
    );
}
